import React from "react";
import LoginPage from "./views/LoginPage";
import { LoginContextProvider } from "./LoginView";
import ClearDataOnLoad from "../../components/ClearDataOnLoad/ClearDataOnLoad";

const Login = () => {
  return (
    <ClearDataOnLoad>
      <LoginContextProvider>
        <LoginPage />
      </LoginContextProvider>
    </ClearDataOnLoad>
  );
};

export default Login;
